module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('a', {
    attrs: {
      "id": "fullscreen"
    },
    on: {
      "click": function($event) {
        _vm.enterFullscreen()
      }
    }
  }, [_vm._v("FULL SCREEN")]), _vm._v(" "), _c('nav-menu'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-59599039"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 124
// module chunks = 1